import { render, staticRenderFns } from "./bestAustraliaAdd.vue?vue&type=template&id=f2f58a82&"
import script from "./bestAustraliaAdd.vue?vue&type=script&lang=js&"
export * from "./bestAustraliaAdd.vue?vue&type=script&lang=js&"
import style0 from "./bestAustraliaAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports